import { style } from '@vanilla-extract/css';
import { bodyTextPreset, borderWidthVars } from '@tundr/ds-foundations';
import { semanticTokenVars } from '@tundr/ds-tokens';
import {
  SELECTION_CONTROL_FOCUS_RING_OFFSET,
  SELECTION_CONTROL_ROW_HEIGHT,
  selectionControlRowBase,
} from '../../_shared/styles/selectionControl';

export const rootClass = style({
  ...selectionControlRowBase,
  width: 'fit-content',

  selectors: {
    '&[data-disabled]': {
      cursor: 'not-allowed',
    },
  },
});

export const rootFullWidthClass = style({
  width: '100%',
});

export const rootMultilineClass = style({
  alignItems: 'flex-start',
});

export const controlClass = style({
  display: 'flex',
});

export const indicatorClass = style({
  selectors: {
    [`${rootClass}:not([data-disabled]):hover &`]: {
      boxShadow: `0 0 0 6px ${semanticTokenVars.surface.background.neutral.default.raised}`,
    },
    [`${rootClass}:has(input:focus-visible) &`]: {
      outline: `${borderWidthVars.xs} solid ${semanticTokenVars.border.brand.base}`,
      outlineOffset: SELECTION_CONTROL_FOCUS_RING_OFFSET,
    },
  },
});

export const labelClass = style({
  ...bodyTextPreset,
  width: '100%',
  color: semanticTokenVars.content.default.default,
  height: SELECTION_CONTROL_ROW_HEIGHT,
  boxSizing: 'border-box',
  minWidth: 0,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  selectors: {
    [`${rootClass}[data-disabled] &`]: {
      color: semanticTokenVars.content.disabled.default,
    },
  },
});

export const labelMultilineClass = style({
  height: 'auto',
  whiteSpace: 'normal',
  overflow: 'visible',
  textOverflow: 'clip',
});
